import React from 'react';
import './back-link.scss';
import { handleEnterKeyPress } from '../../utilities/utils';

type BackLinkProps = {
	onClick: () => void;
	text?: string;
	showIcon?: boolean;
	testId?: string;
};

const BackLink = ({
	onClick,
	text = 'Back to Landing Page',
	showIcon = true,
	testId = '',
}: BackLinkProps) => {
	return (
		<div className="back-link-container">
			<a
				onClick={onClick}
				className="back-link"
				tabIndex={0}
				data-testid={testId}
				onKeyDown={(e) => handleEnterKeyPress(e, onClick)}
			>
				{showIcon && <span className="back-icon">{'<'}</span>}
				<span>{text}</span>
			</a>
		</div>
	);
};

export default BackLink;
